import { Component, OnInit, OnChanges, Input, SimpleChanges, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { CUtilForme, CCalcForme, IInputCotation, CShape99 } from 'src/app/classes/info-forme';
import { CUtilit } from 'src/app/classes/utilit';
import { Shape99InfoLine, Formes, JsLineWMesh } from 'src/app/classes/json-interface';
import { WMeshUtils } from 'src/app/classes/mesh-utils';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'arma-shape',
  templateUrl: './arma-shape.component.html',
  styleUrls: ['./arma-shape.component.css']
})
export class ArmaShapeComponent implements OnInit, OnChanges {

  @Input() public shape?: Formes;  // Forme à afficher
  @Input() public filantRepart?: number; // index des répartitions liées
  @Input('shape99') public mShape99?: Shape99InfoLine[];
  @Input('wmesh') public mWeldedMesh?: JsLineWMesh;
  @Input() public Entermeasure: boolean = true;
  @Input() public width: number = 250;  // En pixel
  @Input() public height: number = 100; // En pixel
  @Input() public Stretch: boolean = false; // Indique si l'on veux étirer la forme pour rentrée dans les dimmension du canvans donnée (width & height)
  @Input() public CenterShape: boolean = true; // Indique si l'on veux centrer la forme sur l'axe X & Y
  @Input() public AddBorder: boolean = false; // Si l'on veux afficher une bordure autour de la forme
  @Input() public HighlightMeasureId: number = -1; // Utiliser pour mettre en surbirlance l'une des cote/measure de la forme
  // Important, dans le cas ou l'on souhaite utiliser plusieurs fois le composant, pour eviter d'avoir deux fois le même id dans une seule page on peut prefixer depuis le composant parrent l'id
  @Input('id') public prefixId?: string;
  // Pour le décorticage avec un banana case pour le double binding, permet de maj les cotes calculer depuis le serveur rest
  @Input('ArrayCote') mArrayCote: string[] = []; // Contiens les valeurs associé au input dans le html // Correspond au valeurs des cotations
  @Input('disabledInput') mDisabledInput: boolean = false; // Permet de désavtiver les input

  @Output() public InputFocus = new EventEmitter<FocusEvent>(); // Remonte la cote que l'on a focus
  @Output('selfRef') public elementRef = new EventEmitter<ElementRef<ArmaShapeComponent>>(); // Pour remonter le composant lui même au parent dans le cas d'une boucle sur le selector, sinon utiliser Template reference (#var) !

  @ViewChild('armaShapeCanvas', {static: true}) mCanvas!: ElementRef<HTMLCanvasElement>; // Ref au canvas dans l'html

  mArrayInput: IInputCotation[] = [];  // Contiens les input des cotes qui seront affiché dans le html

  constructor(private mElementRef: ElementRef<ArmaShapeComponent>) { }

  ngOnInit(): void {
    // On retourne un avertisement si l'on na pas définit l'id du selector
    if (this.prefixId === undefined) {
      //this.prefixId = (Math.floor(Math.random() * (5000 - 0)) + 0).toString();
      console.warn('selector \'id\' must be set', this.prefixId);
    }
    this.elementRef.emit(this.mElementRef); // On emet la reference qu'une seule fois, lors de la création de celui ci
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Recharge l'affichage de la forme si l'on modifie la taille ou le code forme
    if (
      changes['shape'] ||
      changes['mShape99'] ||
      changes['width'] ||
      changes['height'] ||
      changes['Stretch'] ||
      changes['CenterShape'] ||
      changes['filantRepart'] ||
      changes['mWeldedMesh']
    ) {
      this.reloadShape();
    }
  }

  reloadShape() {
    if (this.shape) { // si this.shape est true
      this.mCanvas.nativeElement.height = this.height;      //la hauteur du canvas sera = à la hauteur de la valeur entrer dans l'input "height"
      this.mCanvas.nativeElement.width = this.width;        //la largeur du canvas sera = à la largeur de la valeur entrer dans l'input "largeur"
      const calcForme = CCalcForme.CreateFromForme(this.shape, this.mCanvas.nativeElement, this.Stretch, this.CenterShape);   // création d'une variable contenant la fonction qui permet de créer la forme en fonction des params
      // Dessin de la forme
      CUtilForme.drawShapeInCanvas(this.mCanvas.nativeElement, calcForme); // Utilisation de la fonction qui permet de dessiné la forme passer en param dans le canvas
      // Dessin des cote & recupera tion des inputs
      if (this.Entermeasure) {          // si Entermeasure est false
        this.mArrayInput = CUtilForme.drawAndGetInput(this.mCanvas.nativeElement, calcForme); // utilisation de la fonction qui permet de dessiné les côtes dans le canvas. retourne des données qui permette de mettre une balise input a un endroit précis dans le html
      } else {
        CUtilForme.drawAndGetInput(this.mCanvas.nativeElement, calcForme, false, true, true); // fonction qui permet de dessiné les mesures sur le canvas ou l'exemple des mesures.
        this.mArrayCote = [];
      }
    } else if (this.mShape99 && this.mShape99.length > 0) { // ou si this.mShape99 est true et que sa longueur est > à 0
      this.mCanvas.nativeElement.width = this.width;      //la hauteur du canvas sera = à la hauteur de la valeur entrer dans l'input "height"
      this.mCanvas.nativeElement.height = this.height;    //la largeur du canvas sera = à la largeur de la valeur entrer dans l'input "largeur"
      this.mArrayInput = [];
      this.mArrayCote = [];
      const shape99 = new CShape99(this.mCanvas.nativeElement, this.mShape99, false);    // utilisation de la fonction spécifique à Shape99 pour dessiné la forme 99
      if (!this.Entermeasure)
        shape99.positionShape = CShape99.CST_POSITION.POS_CENTER;
      shape99.drawInCanvas(true, this.Entermeasure);
      /*
      // TEST, soucis avec le scaling + pb sur certainne dimmension
      // Transforme la forme 99 en liste de phase comme sur armaor pour pouvoir faire le dessin sur un canvas
      let arrayPhaseProd = PhaseProduction.getListPhaseProdFromShape99(this.mShape99);
      // TODO, ajouter le diameter & le former
      DrawPhaseProduction.draw(arrayPhaseProd, this.mCanvas.nativeElement, 10, 40);
      */

    } else if (this.mWeldedMesh !== undefined) {
      CUtilForme.clearCanvas(this.mCanvas.nativeElement);
      this.mCanvas.nativeElement.width = Math.min(this.width, this.height);
      this.mCanvas.nativeElement.height = Math.min(this.width, this.height);
      // Dessin du mesh
      WMeshUtils.drawMesh(this.mCanvas.nativeElement, this.mWeldedMesh.vertical, this.mWeldedMesh.horizontal);
    } else {
      CUtilForme.clearCanvas(this.mCanvas.nativeElement);     //  sinon on efface complétement le contenue du Canvas
      this.mArrayInput = [];    // et on vide le tableau mArrayInput
    }
    //Dessin du numéro des répartitions liées
    if (this.filantRepart) {
      const ctx = this.mCanvas.nativeElement.getContext('2d');
      if (ctx == null)
        return;
      ctx.font = '16px Arial';
      ctx.textAlign = 'left';
      ctx.fillStyle = 'red';
      const listeFilants: number[] = CUtilit.IntToBinArray(this.filantRepart);
      let filantText = '';
      //ctx.beginPath();
      listeFilants.forEach((filant, index) => {
        if (filant == 1) {
          filantText += ' ' + (index + 1).toString();
        }
      });
      ctx.fillText(filantText, this.mCanvas.nativeElement.width - 10 - ctx.measureText(filantText).width, this.mCanvas.nativeElement.height - 15);
    }
  }

  onInputFocus(event: FocusEvent) {
    this.InputFocus.emit(event);
  }

  /**
   * Pour les input des cote de la forme
   */
  generateCSSInputMeasure(cotation: IInputCotation, indexCote: number) {
    const css: any = {};
    if (this.HighlightMeasureId == indexCote) {
      css['background-color'] = 'green';
    }
    // Remplisage du CSS
    css.left = cotation.X + 'px';
    css.top = cotation.Y + 'px';
    css.height = cotation.Height + 'px';
    css.width = cotation.Width + 'px';
    css['border-color'] = this.mArrayCote[cotation.Id] ? 'rgb(85, 85, 85, 0)' : 'rgb(85, 85, 85)';
    css['font-size'] = '12px';

    return css;
  }

  isInputMeasureLocked(idInput: number): boolean {
    if (this.shape === undefined) return true;
    return CUtilForme.isCalculatedMeasure(this.shape, idInput);
  }

  public get mainDivCss(): any {
    const result: any = {};
    result['height'] = this.height + 'px';
    result['width'] = this.width + 'px';
    if (this.AddBorder)
      result['border'] = 'solid 1px';
    return result;
  }

}

/** Classe utilitaire pour ArmaShape */
export class ArmaShapeUtilit {
  public static getArrayOfMeasuerInput(idArmaShape: string): HTMLInputElement[] {
    return CUtilit.findInputsInHtmlElement(document.getElementById('ArmaShapeContainer-' + idArmaShape));
  }

  /**
   * Retourne l'id d'un input cote en fonction de l'id d'ArmaShape & du numéro de la mesure
   */
  public static getHTMLInputMeasure(idArmaShape: any, idMeasure: any): string {
    return 'measure-' + idArmaShape + '-' + idMeasure;
  }
}
